module.exports = __webpack_public_path__ + "static/img/son5.54a3fd60.jpg";